import { render, staticRenderFns } from "./BillingOrderDialogDeleteOrder.vue?vue&type=template&id=054a8aa2&scoped=true"
import script from "./BillingOrderDialogDeleteOrder.vue?vue&type=script&lang=js"
export * from "./BillingOrderDialogDeleteOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054a8aa2",
  null
  
)

export default component.exports